export const SET_EMAIL_LOADING = 'SET_EMAIL_LOADING';
export const CLEAR_EMAIL_MESSAGE = 'CLEAR_EMAIL_MESSAGE';
export const CLEAR_EMAIL_ERROR = 'CLEAR_EMAIL_ERROR';
export const CLEAR_EMAIL_PREVIEW = 'CLEAR_EMAIL_PREVIEW';

// =========================
// Templates
// =========================
export const GET_ALL_EMAIL_TEMPLATES_REQUEST = 'GET_ALL_EMAIL_TEMPLATES_REQUEST';
export const GET_ALL_EMAIL_TEMPLATES_SUCCESS = 'GET_ALL_EMAIL_TEMPLATES_SUCCESS';
export const GET_ALL_EMAIL_TEMPLATES_FAIL = 'GET_ALL_EMAIL_TEMPLATES_FAIL';

export const GET_EMAIL_TEMPLATE_REQUEST = 'GET_EMAIL_TEMPLATE_REQUEST';
export const GET_EMAIL_TEMPLATE_SUCCESS = 'GET_EMAIL_TEMPLATE_SUCCESS';
export const GET_EMAIL_TEMPLATE_FAIL = 'GET_EMAIL_TEMPLATE_FAIL';

export const CREATE_EMAIL_TEMPLATE_REQUEST = 'CREATE_EMAIL_TEMPLATE_REQUEST';
export const CREATE_EMAIL_TEMPLATE_SUCCESS = 'CREATE_EMAIL_TEMPLATE_SUCCESS';
export const CREATE_EMAIL_TEMPLATE_FAIL = 'CREATE_EMAIL_TEMPLATE_FAIL';

export const UPDATE_EMAIL_TEMPLATE_REQUEST = 'UPDATE_EMAIL_TEMPLATE_REQUEST';
export const UPDATE_EMAIL_TEMPLATE_SUCCESS = 'UPDATE_EMAIL_TEMPLATE_SUCCESS';
export const UPDATE_EMAIL_TEMPLATE_FAIL = 'UPDATE_EMAIL_TEMPLATE_FAIL';

export const DELETE_EMAIL_TEMPLATE_REQUEST = 'DELETE_EMAIL_TEMPLATE_REQUEST';
export const DELETE_EMAIL_TEMPLATE_SUCCESS = 'DELETE_EMAIL_TEMPLATE_SUCCESS';
export const DELETE_EMAIL_TEMPLATE_FAIL = 'DELETE_EMAIL_TEMPLATE_FAIL';

// =========================
// Placeholders / Preview
// =========================
export const GET_EMAIL_PLACEHOLDERS_REQUEST = 'GET_EMAIL_PLACEHOLDERS_REQUEST';
export const GET_EMAIL_PLACEHOLDERS_SUCCESS = 'GET_EMAIL_PLACEHOLDERS_SUCCESS';
export const GET_EMAIL_PLACEHOLDERS_FAIL = 'GET_EMAIL_PLACEHOLDERS_FAIL';

export const PREVIEW_EMAIL_TEMPLATE_REQUEST = 'PREVIEW_EMAIL_TEMPLATE_REQUEST';
export const PREVIEW_EMAIL_TEMPLATE_SUCCESS = 'PREVIEW_EMAIL_TEMPLATE_SUCCESS';
export const PREVIEW_EMAIL_TEMPLATE_FAIL = 'PREVIEW_EMAIL_TEMPLATE_FAIL';

// =========================
// User Emails
// =========================
export const SEND_ACCOUNT_ACTIVATION_REQUEST = 'SEND_ACCOUNT_ACTIVATION_REQUEST';
export const SEND_ACCOUNT_ACTIVATION_SUCCESS = 'SEND_ACCOUNT_ACTIVATION_SUCCESS';
export const SEND_ACCOUNT_ACTIVATION_FAIL = 'SEND_ACCOUNT_ACTIVATION_FAIL';

// =========================
// Logs
// =========================
export const GET_EMAIL_LOGS_REQUEST = 'GET_EMAIL_LOGS_REQUEST';
export const GET_EMAIL_LOGS_SUCCESS = 'GET_EMAIL_LOGS_SUCCESS';
export const GET_EMAIL_LOGS_FAIL = 'GET_EMAIL_LOGS_FAIL';

export const REQUEST_PASSWORD_RESET_REQUEST = 'REQUEST_PASSWORD_RESET_REQUEST';
export const REQUEST_PASSWORD_RESET_SUCCESS = 'REQUEST_PASSWORD_RESET_SUCCESS';
export const REQUEST_PASSWORD_RESET_FAIL = 'REQUEST_PASSWORD_RESET_FAIL';

export const CONFIRM_PASSWORD_RESET_REQUEST = 'CONFIRM_PASSWORD_RESET_REQUEST';
export const CONFIRM_PASSWORD_RESET_SUCCESS = 'CONFIRM_PASSWORD_RESET_SUCCESS';
export const CONFIRM_PASSWORD_RESET_FAIL = 'CONFIRM_PASSWORD_RESET_FAIL';

export const CLEAR_PASSWORD_RESET_STATE = 'CLEAR_PASSWORD_RESET_STATE';


// =========================
// Action creators
// =========================
export const setEmailLoading = (loading) => ({
    type: SET_EMAIL_LOADING,
    payload: loading
});

export const clearEmailMessage = () => ({
    type: CLEAR_EMAIL_MESSAGE
});

export const clearEmailError = () => ({
    type: CLEAR_EMAIL_ERROR
});

export const clearEmailPreview = () => ({
    type: CLEAR_EMAIL_PREVIEW
});

// ---------- Templates ----------
export const getAllEmailTemplatesRequest = () => ({
    type: GET_ALL_EMAIL_TEMPLATES_REQUEST
});

export const getAllEmailTemplatesSuccess = (templates) => ({
    type: GET_ALL_EMAIL_TEMPLATES_SUCCESS,
    payload: templates
});

export const getAllEmailTemplatesFail = (error) => ({
    type: GET_ALL_EMAIL_TEMPLATES_FAIL,
    error
});

export const getEmailTemplateRequest = (id) => ({
    type: GET_EMAIL_TEMPLATE_REQUEST,
    payload: { id }
});

export const getEmailTemplateSuccess = (template) => ({
    type: GET_EMAIL_TEMPLATE_SUCCESS,
    payload: template
});

export const getEmailTemplateFail = (error) => ({
    type: GET_EMAIL_TEMPLATE_FAIL,
    error
});

export const createEmailTemplateRequest = (templateData) => ({
    type: CREATE_EMAIL_TEMPLATE_REQUEST,
    payload: templateData
});

export const createEmailTemplateSuccess = (template) => ({
    type: CREATE_EMAIL_TEMPLATE_SUCCESS,
    payload: template
});

export const createEmailTemplateFail = (error) => ({
    type: CREATE_EMAIL_TEMPLATE_FAIL,
    error
});

export const updateEmailTemplateRequest = (id, templateData) => ({
    type: UPDATE_EMAIL_TEMPLATE_REQUEST,
    payload: { id, templateData }
});

export const updateEmailTemplateSuccess = (template) => ({
    type: UPDATE_EMAIL_TEMPLATE_SUCCESS,
    payload: template
});

export const updateEmailTemplateFail = (error) => ({
    type: UPDATE_EMAIL_TEMPLATE_FAIL,
    error
});

export const deleteEmailTemplateRequest = (id) => ({
    type: DELETE_EMAIL_TEMPLATE_REQUEST,
    payload: { id }
});

export const deleteEmailTemplateSuccess = (id) => ({
    type: DELETE_EMAIL_TEMPLATE_SUCCESS,
    payload: { id }
});

export const deleteEmailTemplateFail = (error) => ({
    type: DELETE_EMAIL_TEMPLATE_FAIL,
    error
});

// ---------- Placeholders / Preview ----------
export const getEmailPlaceholdersRequest = (contextType) => ({
    type: GET_EMAIL_PLACEHOLDERS_REQUEST,
    payload: { contextType }
});

export const getEmailPlaceholdersSuccess = (placeholders) => ({
    type: GET_EMAIL_PLACEHOLDERS_SUCCESS,
    payload: placeholders
});

export const getEmailPlaceholdersFail = (error) => ({
    type: GET_EMAIL_PLACEHOLDERS_FAIL,
    error
});

export const previewEmailTemplateRequest = (templateCode, variables = {}) => ({
    type: PREVIEW_EMAIL_TEMPLATE_REQUEST,
    payload: { templateCode, variables }
});

export const previewEmailTemplateSuccess = (preview) => ({
    type: PREVIEW_EMAIL_TEMPLATE_SUCCESS,
    payload: preview
});

export const previewEmailTemplateFail = (error) => ({
    type: PREVIEW_EMAIL_TEMPLATE_FAIL,
    error
});

// ---------- User emails ----------
export const sendAccountActivationRequest = (username) => ({
    type: SEND_ACCOUNT_ACTIVATION_REQUEST,
    payload: { username }
});

export const sendAccountActivationSuccess = (data) => ({
    type: SEND_ACCOUNT_ACTIVATION_SUCCESS,
    payload: data
});

export const sendAccountActivationFail = (error) => ({
    type: SEND_ACCOUNT_ACTIVATION_FAIL,
    error
});

// ---------- Logs ----------
export const getEmailLogsRequest = () => ({
    type: GET_EMAIL_LOGS_REQUEST
});

export const getEmailLogsSuccess = (logs) => ({
    type: GET_EMAIL_LOGS_SUCCESS,
    payload: logs
});

export const getEmailLogsFail = (error) => ({
    type: GET_EMAIL_LOGS_FAIL,
    error
});


export const requestPasswordResetRequest = (identifier) => ({
    type: REQUEST_PASSWORD_RESET_REQUEST,
    payload: { identifier }
});

export const requestPasswordResetSuccess = (data) => ({
    type: REQUEST_PASSWORD_RESET_SUCCESS,
    payload: data
});

export const requestPasswordResetFail = (error) => ({
    type: REQUEST_PASSWORD_RESET_FAIL,
    error
});

export const confirmPasswordResetRequest = (token, newPassword, confirmPassword) => ({
    type: CONFIRM_PASSWORD_RESET_REQUEST,
    payload: { token, newPassword, confirmPassword }
});

export const confirmPasswordResetSuccess = (data) => ({
    type: CONFIRM_PASSWORD_RESET_SUCCESS,
    payload: data
});

export const confirmPasswordResetFail = (error) => ({
    type: CONFIRM_PASSWORD_RESET_FAIL,
    error
});

export const clearPasswordResetState = () => ({
    type: CLEAR_PASSWORD_RESET_STATE
});